import React from "react";
import styles from "./LogoNavBarAstroProfiles.module.scss";
import { UserAstroProfile } from "../../Enum";

interface LogoNavBarAstroProfileProps {
  activeProfile: number;
  setActiveProfile: (index: number) => void;
  profiles: UserAstroProfile[];
}

const LogoNavBarAstroProfiles = ({
  setActiveProfile,
  profiles,
}: LogoNavBarAstroProfileProps) => {
  return (
    <div className={styles.navWrapper}>
      <p className={styles.label}>Recent</p>
      <ul className={styles.navLogoContainer}>
        {/*<li*/}
        {/*  className={`${styles.navElement}`}*/}
        {/*  onClick={() => setActiveProfile(0)}*/}
        {/*>*/}
        {/*  <div className={styles.logoWrapper}>*/}
        {/*    <Image src={Images.iconPlus} alt="plus" width={24} height={24} />*/}
        {/*  </div>*/}
        {/*  <span>New</span>*/}
        {/*</li>*/}
        {profiles?.map(({ id, firstName, lastName }, index) => {
          return (
            <li
              className={`${styles.navElement}`}
              key={`${id}-${index}`}
              onClick={() => setActiveProfile(index)}
            >
              <div className={styles.logoWrapper}>
                {firstName?.trim()[0]?.toUpperCase()}
              </div>
              <span>
                {firstName} {lastName}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LogoNavBarAstroProfiles;
